export default "__VITE_ASSET__BvPk6D09__"